import type { ConfigOptions } from "export-to-csv";

// trigger browser to download a CSV using export-to-csv
export async function downloadCSV(rows: CSVRow[], options: ConfigOptions) {
  // dynamic import since export-to-csv is only used in one place
  const ExportToCsv = await import("export-to-csv");

  // make config
  const defaults: ConfigOptions = {
    replaceUndefinedWith: "",
    useKeysAsHeaders: true,
  };
  const config = ExportToCsv.mkConfig({ ...defaults, ...options });

  // normalize rows, generate CSV
  const processed = rows.map((r) => mapValues(r, normalizeValue));
  const csv = ExportToCsv.generateCsv(config)(processed);

  // download
  ExportToCsv.download(config)(csv);
}

function normalizeValue(value: CSVValue): Exclude<AcceptedData, null> {
  if (value === null) return undefined; // needed for replaceUndefinedWith
  if (value instanceof Date) return Util.isoString(value); // date => str
  return value;
}

// from export-to-csv
type AcceptedData = number | string | boolean | null | undefined;

export type CSVValue = AcceptedData | Date;
export type CSVRow = Record<string, CSVValue>;
